import React from 'react';
import Input from '../ShareholderDetails/Input';
import { TInfoltd } from '../../../types';

type TProps = {
  step1: TInfoltd;
};
const NatureOfBusiness = ({ step1 }: TProps) => {
  //   console.log(step1);
  return (
    <div className='my-5'>
      <div className='text-[13px] font-[600] text-[#028789] mb-4'>Nature of Organization</div>

      <div className='sl:flex justify-between gap-6'>
        <Input
          label={'Organization Segment'}
          value={step1.businessSegment}
          style='sl:w-[50%]'
          readonly
        />

        {/* <Input
          label={'Nature of Business'}
          value={step1.businessNature}
          style='sl:w-[30%]'
          readonly
        /> */}
        <Input
          label={'Organization Structure'}
          value={step1.structureOfBusiness ?? 'Incorporated Trustees'}
          style='sl:w-[50%]'
          readonly
        />
      </div>

      <div>
        <Input label={'Organization Description'} value={step1.businessDesc} style='' readonly />
      </div>
    </div>
  );
};

export default NatureOfBusiness;
